import { render, staticRenderFns } from "./toggle-anonymous.vue?vue&type=template&id=2b13dd98"
import script from "./toggle-anonymous.vue?vue&type=script&lang=js"
export * from "./toggle-anonymous.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports